import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Validators } from '@angular/forms';

import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ValidationService as CoreValidationService } from '@bayclubs/ui-core';

import { PersonModel } from '@bayclubs/court-booking-employee-api';

import { ValidationService } from '@shared/shared.module';

import { CourtBookingSaveFacade } from '../../+store/court-booking-save.facade';

@Component({
    selector: 'app-court-booking-save-player-add-new',
    templateUrl: './court-booking-save-player-add-new.component.html',
    styleUrls: ['./court-booking-save-player-add-new.component.scss'],
    standalone: false
})
export class CourtBookingSavePlayerAddNewComponent implements OnInit, OnDestroy {
    @Input() players: PersonModel[];
    @Output() selectPerson: EventEmitter<PersonModel> = new EventEmitter();

    form: UntypedFormGroup;

    subscription: Subscription = new Subscription();

    constructor(
        private formBuilder: UntypedFormBuilder,
        private courtBookingSaveFacade: CourtBookingSaveFacade,
        private coreValidation: CoreValidationService
    ) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            search: [null, [
                Validators.required,
                ValidationService.oneOfValidator(
                    [this.coreValidation.emailValidator(), this.coreValidation.phoneNumberValidator],
                    { invalidEmailOrPhone: true }
                )
            ]]
        });
        this.initFormSubscription();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    initFormSubscription() {
        this.subscription.add(
            this.form.controls.search.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
                if (this.form.valid) {
                    this.courtBookingSaveFacade.searchPlayers(value);
                } else {
                    this.courtBookingSaveFacade.clearPlayers();
                }
            })
        );
    }

    onSelectPerson(person: PersonModel) {
        this.form.controls.search.setValue(null);
        this.selectPerson.emit(person);
    }

    addNewPerson() {
        const selectedPerson = {} as PersonModel;
        selectedPerson.personId = null;
        if (this.coreValidation.phoneNumberValidator(this.form.controls.search as UntypedFormControl) === null) {
            selectedPerson.phoneNumber = this.form.controls.search.value;
        } else {
            selectedPerson.eMail = this.form.controls.search.value;
        }
        this.onSelectPerson(selectedPerson);
    }

    get canAddNewPlayer(): boolean {
        return this.form.valid && (this.players === null || (this.players !== null && this.players.length === 0));
    }

    get showAddPlayerExists(): boolean {
        return this.players && this.players.length > 0;
    }

    get showPlayerList(): boolean {
        return this.players && this.players.length > 0 && this.form.controls.search.value !== null;
    }
}
